<template>
  <div>
    <img
      src="../../assets/error-pages/Bear-box.png"
      style="width: 30%; display: block; margin-left: auto; margin-right: auto; margin-top: 100px"
      alt="bear with it's head in a box"
    />
    <h2 style="text-align: center">Sorry!</h2>
    <h2 style="text-align: center">We couldn't find that for you.</h2>
    <div
      style="margin-top: 30px; display: flex; justify-content: center"
      data-test="404-error-page"
    >
      <a class="btn btn-default-back" href="/home" data-test="404-home-button"> Back to Home </a>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
